import appConfig from "../appconfig";
import {ADD_PRODUCT_SELECTION_TO_CART, SET_VOUCHER_PRODUCT_ADD_TO_CART} from "../store/mutation-types";
import routeMapper from "../router/routeMapper";
import ProductSelection from "../domains2/orders/ProductSelection";


async function voucherProductAddToCart(thisObj) {
	const {productId, voucherId} = thisObj.$store.getters.voucherReward || {};
	const globalSelectedShop = thisObj.$store.getters.globalSelectedShop;
	if (globalSelectedShop) {
		if (productId) {
			await addProductToCart(thisObj, productId, voucherId);
			thisObj.$router.push({
				name: routeMapper.routeNames.checkoutCart,
				params: {
					voucherCode: voucherId
				}
			});
			thisObj.$store.commit(SET_VOUCHER_PRODUCT_ADD_TO_CART, null);
		}
	} else {
		thisObj.$router.push({
			name: routeMapper.routeNames.shopSelection
		});
	}
}

async function addProductToCart(thisObj, productId, voucherId) {
	const psOptions = {
		expiration: {
			tenantSettings: thisObj.$store.getters.tenantSettings.productSelectionExpiration,
			tenantConfig: appConfig.tenantConfig.productSelectionExpiration
		}
	};
	let product;
	try {
		product = thisObj.$store.getters.productCatalog.getProduct(productId);
	} catch (e) {
		thisObj.$store.commit(SET_VOUCHER_PRODUCT_ADD_TO_CART, null);
		throw e;
	}
	const ps = ProductSelection.createFromProduct(product, psOptions);
	ps.quantity = ps.quantity || 1;
	ps.voucherId = voucherId;
	await thisObj.$store.dispatch(ADD_PRODUCT_SELECTION_TO_CART, ps);
}

export {voucherProductAddToCart, addProductToCart};